export enum ERROR_CODES {
  NOT_EXIST = 10,
  RECOVERING_ERROR = 11,
  TOKEN_EXPIRED = 12,
  AD_ACCOUNT_NOT_EXIST = 13,
  TOKEN_NOT_EXIST = 14,
  NOTIFY_AUDIENCE = 20,
  NAME_DUPLICATED = 30,
  TOKEN_DUPLICATED = 31,
  NATIVE_AD_TEMPLATE_DUPLICATED = 32,
  NATIVE_AD_TEMPLATE_DEFAULT = 33,
  ERROR = 10000,
  MANDATORY = 10001,
  APIKEY_MISSING = 10002,
  APIKEY_INVALID = 10003,
  ACCESS_BLOCKED_OR_NOT_PERMISSIONS = 10004,
  ACCESS_TOKEN_MISSING = 10005,
  ACCESS_TOKEN_INVALID = 10006,
  ACCESS_TOKEN_NOT_EXISTS = 10007,
  ACCESS_TOKEN_WITHOUT_PRIVILEGES = 10008,
  OAUTH_ERROR = 10009,
  OAUTH_USER_INVALID = 10010,
  OAUTH_PROCESS_STORAGE = 10011,
  OAUTH_CLIENT_INVALID = 10012,
  ACCESS_TOKEN_NOT_FOR_USER = 10013,
  ACCESS_TOKEN_EXPIRED = 10014,
  EVENT_COLLISION = 10015,
  EMAIL_ALREADY_EXIST = 10016,
  MFA_ENABLED = 10017,
  ACCOUNT_INVALID = 10018,
  ACTIVATION_TOKEN_INVALID = 10019,
  USER_NOT_VERIFIED = 10020,
  OAUTH_LOGIN_FAILS_EXCEED = 10021,
  OAUTH_CLIENT_SECRET_INVALID = 10022,
  MANDATORY_PLAN_TO_REGISTER = 10023,
  GOOGLE_ADS_CONNECTION_FAIL = 10024,
  GENERIC_MYSQL_ERROR = 10025,
  SHORTLINK_NOT_FOUND = 10026,
  PUSH_SOUND_CREATE_ERROR = 10027,
  PUSH_SOUND_NOT_FOUND = 10028,
  REFRESH_TOKEN_INVALID = 10029,
  REFRESH_TOKEN_EXPIRED = 10030,
  NO_CSRF_TOKEN_COOKIE = 10031,
  NO_CSRF_TOKEN_BODY = 10032,
  FAILED_VERIFY_DOUBLE_CSRF = 10033,
  FAILED_VERIFY_ID_TOKEN_GOOGLE = 10034,
  GOOGLE_PROFILE_INFO = 10035,
  USER_NOT_ACTIVATED = 10036,
  USER_NOT_REGISTERED = 10037,
  SIGNUP_ERROR = 10038,
  // federación de cuentas
  ACCOUNT_FEDERATED_INVALID_EMAIL = 10039,
  EMAIL_FEDERATED_INVALID_ACCOUNT = 10040,
  EMAIL_FEDERATED_FORGOT_PASSWORD = 10041,
  // RENOVACIÓN DE PASSWORD OBLIGATORIA
  USER_REQUIRE_PASSWORD_RENEWAL = 10042,
  // obtención oauth2 token contra microsoft
  MICROSOFT_PROFILE_INFO = 10043,
  FAILED_VERIFY_AUTH_CODE_MICROSFT = 10044,
  CURRENT_PASSWORD_INVALID = 10045,
  PASSWORD_ALREADY_USED_BEFORE = 10046,
  TIKTOK_ADS_CONNECTION_FAIL = 10047,
  // cuando el usuario eliminado intenta loguearse
  USER_IS_DELETED = 10048,
  USER_DELETED_FIRST_FAIL = 10049,
  MEDIA_SOURCE_KOCHAVA_APP_NOT_CONFIGURED = 10050,
  DEMO_APP_READ_ONLY = 10051,
  SKUDO_OFFER_HAS_ACTIVE_URLS = 20001,
  SKUDO_CAMPAIGN_HAS_ACTIVE_OFFERS = 20002,
  SKUDO_PROVIDER_HAS_ACTIVE_URLS = 20003,
  SKUDO_AUTHORIZATION_CODE_INVALID = 20004,
  SKUDO_AUTHORIZATION_CODE_EXPIRED = 20005,
}
